<template>
  <v-dialog v-model="empdialog" width="900px" height="auto" persistent>
    <v-card class="overflow-hidden" height="auto" flat>
      <!-- <v-card-title class="indigo white--text headline">
        User Directory for: Athish Sagar Singh
      </v-card-title>-->
      <v-toolbar dark dense class="header">
        <v-icon>mdi-account</v-icon>
        <span class="ml-3">User Details</span>
        <v-spacer></v-spacer>
        <v-btn class text dark @click="empdialog = false">
          <v-icon color="white" small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-tabs
        :vertical="!isMobile"
        :height="!isMobile ? '240px' : '54px'"
        class="my-tabs"
      >
        <v-tab left active-class="tab1" class="mt-1">
          <v-icon left></v-icon>Basic Details
        </v-tab>
        <v-tab left active-class="tab1"> <v-icon left></v-icon>Address </v-tab>
        <v-tab left active-class="tab1">
          <v-icon left></v-icon>Expense Approvers
        </v-tab>
        <v-tab left active-class="tab1">
          <v-icon left></v-icon>Budget Details
        </v-tab>
        <v-tab left active-class="tab1">
          <v-icon left></v-icon>Card Details
        </v-tab>
        <v-tab left active-class="tab1" class="mb-1">
          <v-icon left></v-icon>User Type Details</v-tab
        >
        <!-- <v-tab left> <v-icon left></v-icon>KYC Details </v-tab> -->
        <!-- <v-tab left> <v-icon left></v-icon>AML Verification</v-tab> -->
        <v-tab-item>
          <v-card
            elevation="1"
            shaped
            class="ma-4"
            align="center"
            justify="center"
            :width="isMobile ? '300' : '635'"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Full Name</b>
                      </span>
                      <br />
                      <span class="caption">
                        {{ itemDetails.full_name }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Date Of Birth</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemDetails.dob != null">
                        {{ itemDetails.dob }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Mobile Number</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemDetails.mobile_no != null"
                      >
                        {{ itemDetails.mobile_no }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Email-Id</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemDetails.email_id != null">
                        {{ itemDetails.email_id }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Nationality</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemDetails.nationality != null"
                      >
                        {{ itemDetails.nationality }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Passport Number</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemDetails.passport != null">
                        {{ itemDetails.passport }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Proxy Number</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemDetails.proxy_no != null">
                        {{ itemDetails.proxy_no }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item style="margin-left: 50px">
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-card
                elevation="1"
                :width="isMobile ? '250' : '350'"
                height="auto"
                class="ml-2 mb-4 mt-5 mr-6"
                shaped
              >
                <span class="ml-5">Registered Address</span>
                <v-row>
                  <v-col cols="12" md="12" lg="12">
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 1</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address.address_line_1 != null"
                        >
                          {{ address.address_line_1 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 2</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address.address_line_2 != null"
                        >
                          {{ address.address_line_2 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 3</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address.address_line_3 != null"
                        >
                          {{ address.address_line_3 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 4</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address.address_line_4 != null"
                        >
                          {{ address.address_line_4 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">City</b>
                        </span>
                        <br />
                        <span class="caption" v-if="address.city != null">
                          {{ address.city }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">State</b>
                        </span>
                        <br />
                        <span class="caption" v-if="address.state != null">
                          {{ address.state }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Country</b>
                        </span>
                        <br />
                        <span class="caption" v-if="address.country != null">
                          {{ address.country }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Postal Code</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address.postal_code != null"
                        >
                          {{ address.postal_code }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-card
                elevation="1"
                :width="isMobile ? '250' : '350'"
                height="auto"
                class="ml-2 mb-4 mt-5 mr-6"
                shaped
              >
                <span class="ml-5">Mailing Address</span>
                <v-row>
                  <v-col cols="12" md="12" lg="12">
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 1</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address1.address_line_1 != null"
                        >
                          {{ address1.address_line_1 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 2</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address1.address_line_2 != null"
                        >
                          {{ address1.address_line_2 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 3</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address1.address_line_3 != null"
                        >
                          {{ address1.address_line_3 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 4</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address1.address_line_4 != null"
                        >
                          {{ address1.address_line_4 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">City</b>
                        </span>
                        <br />
                        <span class="caption" v-if="address1.city != null">
                          {{ address1.city }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">State</b>
                        </span>
                        <br />
                        <span class="caption" v-if="address1.state != null">
                          {{ address1.state }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Country</b>
                        </span>
                        <br />
                        <span class="caption" v-if="address1.country != null">
                          {{ address1.country }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Postal Code</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="address1.postal_code != null"
                        >
                          {{ address1.postal_code }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-row class="mt-0 ml-3 mr-1">
            <v-col cols="12" md="6" lg="6">
              <v-card width="auto" height="auto" class="mt-7" shaped>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Approver 1</b>
                    </span>
                    <span class="subtitle-2" style="margin-left: 130px">
                      <v-icon small color="black" @click="opendialogAppr1()"
                        >mdi-pencil</v-icon
                      >
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver1.approver_name }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Email</b>
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver1.approver_email }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Department Name </b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-for="(dep, key) in approverdep"
                      :key="key"
                    >
                      {{
                        dep.dep_name != undefined
                          ? approverdep.length - 1 != approverdep.indexOf(dep)
                            ? dep.dep_name + ", "
                            : dep.dep_name + "."
                          : "-"
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-card width="auto" height="auto" class="mt-7 mb-7" shaped>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Approver 2</b>
                    </span>
                    <span class="subtitle-2" style="margin-left: 130px">
                      <v-icon small color="black" @click="opendialogAppr2()"
                        >mdi-pencil</v-icon
                      >
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver2.approver_name }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Email</b>
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver2.approver_email }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Department Name</b>
                    </span>
                    <br />
                    <span class="caption">
                      <span
                        class="caption"
                        v-for="(dep, key) in approverdep2"
                        :key="key"
                      >
                        {{
                          dep.dep_name != undefined
                            ? approverdep2.length - 1 !=
                              approverdep2.indexOf(dep)
                              ? dep.dep_name + ", "
                              : dep.dep_name + "."
                            : "-"
                        }}
                      </span>
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-card
            elevation="1"
            shaped
            class="ma-4"
            align="center"
            justify="center"
            :width="isMobile ? '300' : '635'"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Department Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemDetails.dept_details.department_name != null"
                      >
                        {{ itemDetails.dept_details.department_name }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Department Budget</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="
                          itemDetails.dept_details.department_budget != null
                        "
                      >
                        {{ itemDetails.dept_details.department_budget }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Allocated Budget</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemDetails.dept_details.allocated_budget != null"
                      >
                        {{ itemDetails.dept_details.allocated_budget }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Unallocated Budget</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="
                          itemDetails.dept_details.unallocated_budget != null
                        "
                      >
                        {{ itemDetails.dept_details.unallocated_budget }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">User Budget</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemDetails.dept_details.user_budget != null"
                      >
                        {{ itemDetails.dept_details.user_budget }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            elevation="1"
            shaped
            class="ma-4"
            align="center"
            justify="center"
            :width="isMobile ? '300' : '635'"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="card.card_name != null">
                        {{ card.card_name }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Type</b>
                      </span>
                      <br />
                      <span class="Caption" v-if="card.card_type == 1">
                        Non-Personalized</span
                      >
                      <span class="Caption" v-if="card.card_type == 2">
                        Personalized</span
                      >
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Sub Card Type</b>
                      </span>
                      <br />
                      <span class="Caption" v-if="card.sub_card_type == 1">
                        Physical Card</span
                      >
                      <span class="Caption" v-if="card.sub_card_type == 2">
                        Virtual Card</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Number</b>
                      </span>
                      <br />
                      <span class="caption" v-if="card.card_number != null">
                        {{ card.card_number }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Expiry</b>
                      </span>
                      <br />
                      <span class="caption" v-if="card.card_expiry != null">
                        {{ card.card_expiry }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="mt-n5">
          <v-row class="mt-7" style="margin-left: 155px" v-if="isMobile">
            <v-card-actions>
              <v-btn small outlined color="primary" @click="opendialog()">
                <b>EDIT USER TYPE</b>
              </v-btn>
            </v-card-actions>
          </v-row>
          <v-row class="mt-7" style="margin-left: 495px" v-if="!isMobile">
            <v-card-actions>
              <v-btn small outlined color="primary" @click="opendialog()">
                <b>EDIT USER TYPE</b>
              </v-btn>
            </v-card-actions>
          </v-row>
          <v-card
            elevation="1"
            shaped
            class="ma-4"
            align="center"
            justify="center"
            :width="isMobile ? '300' : '635'"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">User Type Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemUsers.user_type_name != null"
                      >
                        {{ itemUsers.user_type_name }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Role Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemUsers.role_name != null">
                        {{ itemUsers.role_name }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Grade Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemUsers.grade_name != null">
                        {{ itemUsers.grade_name }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Location Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemUsers.location_name != null"
                      >
                        {{ itemUsers.location_name }}
                      </span>
                      <span v-else>-</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- <v-tab-item class="mt-n1">
          <v-card flat>
            <v-card-text>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">Document Name:</b>
                  </span>
                </v-col>
                <v-col cols="4">
                  <span class="subtitle-2"> Passport</span></v-col
                >
              </v-row>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">Face Matching Score:</b>
                  </span>
                </v-col>
                <v-col cols="4">
                  <span class="subtitle-2">
                    {{ itemDetails.onfido_details.face_match_score }}
                  </span></v-col
                >
              </v-row>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">Visual Score:</b>
                  </span>
                </v-col>
                <v-col cols="4">
                  <span class="subtitle-2">
                    {{ itemDetails.onfido_details.visual_score }}
                  </span></v-col
                >
              </v-row>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">Documents Uploaded:</b>
                  </span>
                </v-col>
                <v-col cols="4">
                  <v-avatar tile size="36" class="mt-1">
                    <img
                      v-if="
                        documentlist.DocumentExt == 'jpeg' ||
                        documentlist.DocumentExt == 'jpg' ||
                        documentlist.DocumentExt == 'png'
                      "
                      :src="documentlist.document_url"
                      alt="error"
                      @click="openImageInNewTab(documentlist.document_url)"
                    />

                    <v-icon
                      @click="openImageInNewTab(documentlist.document_url)"
                      v-else-if="documentlist.DocumentExt == 'pdf'"
                      left
                      color="blue"
                      >mdi-file-pdf</v-icon
                    >
                    <v-icon
                      @click="openImageInNewTab(documentlist.document_url)"
                      v-else-if="
                        documentlist.DocumentExt == 'xls' ||
                        documentlist.DocumentExt == 'xlsx'
                      "
                      left
                      color="blue"
                      >mdi-file-excel</v-icon
                    >
                    <v-icon
                      @click="openImageInNewTab(documentlist.document_url)"
                      v-else-if="
                        documentlist.DocumentExt == 'doc' ||
                        documentlist.DocumentExt == 'docx'
                      "
                      left
                      color="blue"
                      >mdi-file-word</v-icon
                    >
                    <v-icon
                      @click="openImageInNewTab(documentlist.document_url)"
                      v-else
                      left
                      color="blue"
                      >mdi-file-document</v-icon
                    >
                  </v-avatar>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">Onfido Reports :</b>
                  </span>
                </v-col>
                <v-col cols="4">
                  <v-avatar tile size="36" class="mt-1">
                    <img
                      v-if="
                        reportUrllist.reportExt == 'jpeg' ||
                        reportUrllist.reportExt == 'jpg' ||
                        reportUrllist.reportExt == 'png'
                      "
                      :src="reportUrllist.report_url"
                      alt="error"
                      @click="openImageInNewTab(reportUrllist.report_url)"
                    />

                    <v-icon
                      @click="openImageInNewTab(reportUrllist.report_url)"
                      v-else-if="reportUrllist.reportExt == 'pdf'"
                      left
                      large
                      color="blue"
                      >mdi-file-pdf</v-icon
                    >
                    <v-icon
                      @click="openImageInNewTab(reportUrllist.report_url)"
                      v-else-if="
                        reportUrllist.reportExt == 'xls' ||
                        reportUrllist.reportExt == 'xlsx'
                      "
                      left
                      color="blue"
                      >mdi-file-excel</v-icon
                    >
                    <v-icon
                      @click="openImageInNewTab(reportUrllist.report_url)"
                      v-else-if="
                        reportUrllist.reportExt == 'doc' ||
                        reportUrllist.reportExt == 'docx'
                      "
                      left
                      color="blue"
                      >mdi-file-word</v-icon
                    >
                    <v-icon
                      @click="openImageInNewTab(reportUrllist.report_url)"
                      v-else
                      left
                      color="blue"
                      >mdi-file-document</v-icon
                    >
                  </v-avatar>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item> -->

        <!-- <v-tab-item class="mt-n1">
          <v-card flat>
            <v-card-text>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">AML Data :</b>
                  </span>
                </v-col>
                <v-col cols="6" v-if="aml != ''">
                  <span class="subtitle-2">
                    <b>Scanned on :</b>{{ aml.scanned_on }}
                  </span>
                  <span class="subtitle-2">
                    <b>No. of Matches :</b>{{ aml.no_of_matches }}
                  </span>
                  <span class="subtitle-2" v-if="aml.no_of_matches != 0">
                    <b> Matches :</b>{{ aml.matches }}
                  </span></v-col
                >
              </v-row>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">MOHA Sanctions List :</b>
                  </span>
                </v-col>
                <v-col cols="6" v-if="moha != ''">
                  <span class="subtitle-2">
                    <b>Scanned on :</b>{{ moha.scanned_on }}
                  </span>
                  <span class="subtitle-2">
                    <b>No. of Matches :</b>{{ moha.no_of_matches }}
                  </span>
                  <span class="subtitle-2" v-if="moha.no_of_matches != 0">
                    <b> Matches :</b>{{ moha.matches }}
                  </span></v-col
                >
              </v-row>
              <v-row class="mt-1">
                <v-col cols="4">
                  <span class="subtitle-2">
                    <b class="primary--text">Black List :</b>
                  </span>
                </v-col>
                <v-col cols="6" v-if="blacklist != ''">
                  <span class="subtitle-2">
                    <b> Scanned on :</b>{{ blacklist.scanned_on }}
                  </span>
                  <span class="subtitle-2">
                    <b>No. of Matches :</b>{{ blacklist.no_of_matches }}
                  </span>
                  <span class="subtitle-2" v-if="blacklist.no_of_matches != 0">
                    <b>Matches :</b>{{ blacklist.matches }}
                  </span></v-col
                >
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item> -->
        <!-- <v-tab-item>
          <v-card width="700px" flat>
            <v-row class="justify-center mt-1">
              <div class><strong>Card Balance:</strong>5000RM</div>
            </v-row>
            <v-row>
              <v-card-title class="ml-2 mt-n3 mb-n5 secondary--text"
                >Transaction History</v-card-title
              >
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  dense
                  :headers="balheader"
                  :items="baldata"
                  hide-default-footer
                ></v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item> -->
      </v-tabs>
    </v-card>
    <v-dialog
      v-model="usertypeedit"
      persistent
      max-width="600px"
      height="300px"
    >
      <v-card>
        <v-toolbar color="white" dark class="elevation-0">
          <v-toolbar-title class="black--text ml-2">
            <b>Edit User Type</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon small class="black--text mt-n4" dark @click="dialogclose()"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="1" xl="1" lg="1"></v-col>
            <v-col cols="12" sm="12" xs="12" md="5" xl="5" lg="5">
              <v-select
                label="Select User Type"
                solo
                dense
                outlined
                item-text="user_typename"
                :items="SelectItem"
                v-model="username"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="5" xl="5" lg="5">
              <v-text-field
                label="Role Name"
                dense
                v-model="role_name"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="1" xl="1" lg="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="1" xl="1" lg="1"></v-col>
            <v-col cols="12" sm="12" xs="12" md="5" xl="5" lg="5">
              <v-text-field
                label="Grade Name"
                dense
                readonly
                v-model="grade_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="5" xl="5" lg="5">
              <v-text-field
                label="Location Name"
                dense
                readonly
                v-model="location_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="1" xl="1" lg="1"></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text" small @click="dialogclose()"
            >CANCEL</v-btn
          >
          <v-btn color="primary" small @click="EditUserType()">CONFIRM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ExpenseEdit" persistent max-width="600px" height="300px">
      <v-card>
        <v-toolbar color="white" dark class="elevation-0">
          <v-toolbar-title class="black--text ml-2">
            <b>Edit Expense Approver 1</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon small class="black--text mt-n4" dark @click="dialogcloseNew()"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="6" xl="6" lg="6">
              <v-select
                label="Select Approver"
                solo
                dense
                outlined
                item-text="approver_name"
                :items="Selectdata"
                v-model="approvername"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="6" xl="6" lg="6">
              <v-text-field
                label="Email-Id"
                dense
                v-model="email_id"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text" small @click="dialogcloseNew()"
            >CANCEL</v-btn
          >
          <v-btn color="primary" small @click="EditApprover1()">CONFIRM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="ExpenseAppr2"
      persistent
      max-width="600px"
      height="300px"
    >
      <v-card>
        <v-toolbar color="white" dark class="elevation-0">
          <v-toolbar-title class="black--text ml-2">
            <b>Edit Expense Approver 2</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon
            small
            class="black--text mt-n4"
            dark
            @click="dialogcloseAppr2()"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="6" xl="6" lg="6">
              <v-select
                label="Select Approver"
                solo
                dense
                outlined
                item-text="approver_name"
                :items="Selectdata2"
                v-model="approvername2"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="6" xl="6" lg="6">
              <v-text-field
                label="Email-Id"
                dense
                v-model="email_id2"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            class="white--text"
            small
            @click="dialogcloseAppr2()"
            >CANCEL</v-btn
          >
          <v-btn color="primary" small @click="EditApprover2()">CONFIRM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  props: {
    approver1: Object,
    approver2: Object,
  },

  data: () => ({
    SelectItem: [],
    username: "",
    approvername: "",
    approvername2: "",
    email_id: "",
    email_id2: "",
    role_name: "",
    location_name: "",
    grade_name: "",
    user_type_id: "",
    reportUrllist: {},
    documentlist: {},
    address: {},
    address1: {},
    itemUsers: {},
    userid: "",
    itemDetails: {},
    card: {},
    empdialog: false,
    balheader: [
      { text: "AMOUNT", value: "amount" },
      { text: "DATE", value: "date" },
      { text: "TIME", value: "time" },
    ],
    baldata: [
      { amount: 100, date: "24-03-2021", time: "10:32 am" },
      { amount: 150, date: "25-03-2021", time: "11:32 am" },
    ],
    active: [],
    open: [],
    users: [],
    tab: null,
    tabnames: [
      "Basic Information",
      "Address information",
      "Documents Uploaded",
    ],
    users2: [
      {
        text: "BASIC ",
        icon: "mdi-account-multiple",
        link: "/Employees/Basicview",
      },
      { text: "ADDRESS", icon: "mdi-account-plus", link: "/Admin" },
      { text: "DOCUMENTS", icon: "mdi-currency-btc", link: "/Employees" },
    ],
    usertypeedit: false,
    selectnew: [],
    depNew: "",
    depNew2: "",
    approverdep: [],
    approverdep2: [],
    Department: [],
    Department2: [],
    Selectdata: [],
    Selectdata2: [],
    ExpenseEdit: false,
    ExpenseAppr2: false,
    expapproverid: "",
    expapproverid2: "",
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    username(val) {
      var usertypearray = this.SelectItem.filter((i) => i.user_typename == val);
      this.role_name = usertypearray[0].role_name;
      this.grade_name = usertypearray[0].grade_name;
      this.location_name = usertypearray[0].location_name;
      this.user_type_id = usertypearray[0].user_type_id;
    },
    approvername(val) {
      var usertypearrayAppr = this.Selectdata.filter(
        (i) => i.approver_name == val
      );
      this.email_id = usertypearrayAppr[0].email_id;
      this.expapproverid = usertypearrayAppr[0].exp_approver_id;
    },
    approvername2(val) {
      var usertypearrayAppr2 = this.Selectdata2.filter(
        (i) => i.approver_name == val
      );
      this.email_id2 = usertypearrayAppr2[0].email_id;
      this.expapproverid2 = usertypearrayAppr2[0].exp_approver_id;
    },
    approver1(val) {
      // console.log("val",val)
      this.Department = val;

      this.approverdep = this.Department.department_name;
    },
    approver2(val) {
      this.Department2 = val;
      this.approverdep2 = this.Department2.department_name;
    },
  },
  methods: {
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    async opendialog() {
      this.usertypeedit = true;
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "GUSERTYP",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.SelectItem = responseData.data.data;
        for (let i = 0; i < this.SelectItem.length; i++) {
          this.username = this.SelectItem[i].user_typename;
          // console.log(  this.username);
        }
      }
    },
    async EditUserType() {
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 0,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "UPUSERTYP",
          user_id: this.userid,
          user_type_id: this.user_type_id,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData);

      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.usertypeedit = false;
        this.$emit("backChild");
        this.empdialog = false;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.usertypeedit = false;
        this.empdialog = false;
      }
    },

    async opendialogAppr1() {
      this.ExpenseEdit = true;
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "GETEXPAPP",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.Selectdata = responseData.data.data;
        //  console.log(  this.Selectdata);
        for (let i = 0; i < this.Selectdata.length; i++) {
          this.approvername = this.Selectdata[i].approver_name;
          // console.log(  this.approvername);
          // }
        }
      }
    },

    async EditApprover1() {
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 0,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "UPEXPAPP",
          type: 1,
          user_id: this.userid,
          approver_id: this.expapproverid,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData);

      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.ExpenseEdit = false;
        this.$emit("backChild");
        this.empdialog = false;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.ExpenseEdit = false;
        this.empdialog = false;
      }
    },
    async opendialogAppr2() {
      this.ExpenseAppr2 = true;
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "GETEXPAPP",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.Selectdata2 = responseData.data.data;
        //  console.log(  this.Selectdata2);
        for (let i = 0; i < this.Selectdata2.length; i++) {
          this.approvername2 = this.Selectdata2[i].approver_name;
          // console.log(  this.approvername2);
          // }
        }
      }
    },
    async EditApprover2() {
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 0,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "UPEXPAPP",
          type: 2,
          user_id: this.userid,
          approver_id: this.expapproverid2,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData);

      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.ExpenseEdit = false;
        this.$emit("backChild");
        this.empdialog = false;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.ExpenseEdit = false;
        this.empdialog = false;
      }
    },
    dialogclose() {
      this.usertypeedit = false;
    },
    dialogcloseNew() {
      this.ExpenseEdit = false;
    },
    dialogcloseAppr2() {
      this.ExpenseAppr2 = false;
    },
  },
};
</script>
<style scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
.card {
  border: 1px solid rgb(146, 124, 52);
}
.tab1 {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
</style>
